export default {
  action: 'Ação',
  actionBlockedDueToDuplicateUuid:
    'Ação bloqueada devido a UUID de dispositivo duplicado',
  active: 'Ativo',
  add: 'Adicionar',
  addAnotherIp: 'Adicionar outro IP',
  addDeviceHeaderwoSuite: 'Adicionar dispositivos: {{screen}}',
  addDevices: 'Adicionar dispositivo',
  addIp: 'Adicionar IP',
  addIPAddress: 'Adicionar endereço IP',
  addIpHeader: 'Adicionar endereço IP: {{screen}}',
  addRole: 'Adicionar função',
  addSuite: 'Adicionar suíte',
  addSuiteHeader: 'Adicionar suíte: {{screen}} - Suíte {{suite}}',
  adminRoleWillHaveFullAccess: 'A função de Administrador terá acesso total',
  all: 'Todos',
  and: 'e',
  applianceStatus: 'Status do dispositivo',
  apply: 'Aplicar',
  assignedToDevice: 'Atribuído ao dispositivo',
  availableDevices: 'Dispositivos disponíveis',
  bookingDate: 'Data da reserva',
  bookingRef: 'Referência da reserva',
  bulkEditScreenIPs: 'Edição em massa de IPs de salas',
  bulkHeadingMsg:
    'As alterações feitas aos IPs aqui serão refletidas em todos os dispositivos de sala associados.',
  cancel: 'Cancelar',
  ccEmails: 'E-mails em cópia (CC)',
  certificateAutoSync: 'Sincronização automática de certificado',
  certificateExpired: 'Certificado expirado',
  certificateForAllDevicesMustBeValid:
    'O certificado de todos os dispositivos deve ser válido.',
  certificateNotAvailable:
    'Certificado do dispositivo indisponível para este número de série.',
  certificateNotValid: 'Certificado inválido',
  chain: 'Rede de cinema',
  chainSmall: 'Rede de cinema',
  changesSavedSuccessfully: 'Alterações salvas com sucesso',
  clear: 'Limpar',
  clearAll: 'Limpar tudo',
  clearAllSmall: 'Limpar tudo',
  clearSelection: 'Limpar seleção',
  collapseAll: 'Recolher tudo',
  common: {
    confirm: 'Confirmar',
  },
  composition: 'Composição',
  compositionCount_one: 'Composição (1)',
  compositionCount_other: 'Composição{{plural}} ({{count}})',
  compositionDetails: 'Detalhes da composição',
  compositionName: 'Nome da composição',
  confirmDelete: 'Confirmar exclusão',
  confirmDeleteIP: 'Tem certeza de que deseja excluir o endereço IP {{ip}}?',
  confirmDeleteIPAssigned:
    'Este IP está atribuído no momento e será desconectado do dispositivo: {{deviceInfo}} em {{location}}.',
  confirmDeleteSuite:
    'Tem certeza de que deseja excluir {{screen_name}} - Suíte {{suite_number}}? Escolha uma opção adequada para prosseguir.',
  content: 'Conteúdo',
  contentDetails: 'Detalhes do conteúdo',
  copyLink: 'Copiar link',
  countTheatres_one: '1 Cinema',
  countTheatres_other: '{{count}} Cinemas',
  cplMarkers: 'Marcadores CPL',
  create: 'Criar',
  createdOn: 'Criado em',
  creditOffset: 'Compensação de crédito',
  creditsOffset: 'Compensação de créditos',
  dcpStatusTitle: 'Status do DCP',
  deactivatedUser: 'Usuário desativado',
  delete: 'Excluir',
  deleteIp: 'Excluir IP',
  deleteSuite: 'Excluir suíte',
  deleteTheatreGroup: 'Excluir grupo de cinemas',
  deleteTheatreGroupConfirmation:
    'Tem certeza de que deseja excluir {{groupName}}? Esta ação é permanente e não pode ser desfeita.',
  deleteTheatreWarningMessage:
    'Excluí-lo afetará o acesso associado. Tem certeza de que deseja prosseguir?',
  details: 'Detalhes',
  deviceWillBeRemoved: 'O dispositivo será removido desta suíte',
  deviceModel: 'Modelo do dispositivo',
  deviceRole: 'Função do dispositivo',
  devices: 'Dispositivos',
  deviceWillBeMoved:
    'O dispositivo será movido para os dispositivos da Sala {{destination}} após salvar',
  deviceWillBeMovedToStandby: 'O dispositivo será movido para espera (standby)',
  disabled: 'Desativado',
  doNotIncludePrDevices: 'NÃO inclua dispositivos PR para a geração de KDM.',
  downloadAttempt: 'Tentativa de download',
  downloadDetails: 'Detalhes do download',
  downloadHistory: 'Histórico de downloads',
  downloadKDMs: 'Baixar KDMs',
  downloadLocation: 'Local de download',
  downloadNow: 'Baixar agora',
  downloadProgress: '{{progress}} Concluído',
  downloadSize: 'Tamanho do download',
  downloadStatus: 'Status do download',
  duplicateDeviceFound: 'Dispositivo duplicado encontrado',
  duplicateDeviceWarning:
    'Dispositivo duplicado encontrado em {{screens_and_suites}}',
  editDevice: 'Editar dispositivo',
  editDeviceMeta: 'Editar metadados do dispositivo',
  editIp: 'Editar IP',
  editIpHeader: 'Editar IP - Sala {{screen}}',
  editRoles: 'Editar funções',
  editSuite: 'Editar suíte',
  editSuiteHeader: 'Editar suíte: Sala {{screen}} - Suíte {{suite}}',
  editTheatreGroup: 'Editar grupo de cinemas',
  effectiveFrom: 'Válido a partir de',
  email: 'E-mail',
  emailKDMS: 'Enviar KDMs por e-mail',
  emptyScreen: 'Nenhuma suíte adicionada à sala',
  emptyStandby: 'Nenhum dispositivo em espera (standby)',
  enabled: 'Ativado',
  enterEmail: 'Digite o e-mail',
  enterGateway: 'Digite o gateway',
  enterIpAddress: 'Digite o endereço IP',
  enterSoftwareVersion: 'Digite a versão do software',
  enterSubnetMask: 'Digite a máscara de sub-rede',
  errorDownloadingKDMs: 'Erro ao baixar KDM',
  errorFetching: 'Erro ao buscar dados',
  errorFetchingDevices: 'Erro ao buscar dispositivos',
  errorFetchingFilterSettings: 'Erro ao buscar configurações de filtro',
  errorFetchingGroups: 'Erro ao carregar a lista de grupos',
  errorFetchingUser: 'Erro ao carregar informações do usuário',
  errorFetchingUsersList: 'Erro ao carregar a lista de usuários',
  errorFetchingWireTapCount: 'Erro ao carregar o número total de WireTAPs',
  errorLoadingWireTap: 'Erro ao carregar WireTAPs',
  errorMessage: 'Ocorreu um erro ao processar sua solicitação.',
  errorReportDownload: 'Erro ao baixar o relatório {{report}}: {{error}}',
  errors: {
    fetchDeviceModels: 'Erro ao buscar modelos de dispositivos',
    fetchDeviceRoles: 'Erro ao buscar funções dos dispositivos',
    fetchTheatreInfo: 'Erro ao buscar informações do cinema',
  },
  errorUploadingCertificate: 'Erro ao enviar certificado',
  expandAll: 'Expandir tudo',
  expired: 'Expirado',
  expiredOn: 'Expirado em',
  expiring: 'Expirando (em {{days}} dias)',
  expiring_1: 'Expirando',
  expiryOn: 'Data de expiração',
  failedToDeleteTheatreGroup: 'Falha ao excluir grupo de cinemas',
  failedToDeleteTheatreGroupMessage:
    'Ocorreu um erro ao excluir o grupo de cinemas',
  failedToRemoveUser: 'Falha ao remover usuário',
  failedToSendUserInvite: 'Falha ao enviar convite ao usuário',
  failedToUpdateUser: 'Falha ao atualizar usuário',
  fetchCompositions: 'Erro ao carregar composições',
  fetchingRoles: 'Buscando funções...',
  fetchTheatres: 'Erro ao carregar cinemas',
  filter: 'Filtrar',
  filterBy: 'Filtrar por',
  filterByTheatres: 'Filtrar por cinemas',
  filterPanelCompositionType: 'TIPO DE COMPOSIÇÃO',
  filterPanelCompositionTypeOptions_advertisement: 'Comercial / Anúncio',
  filterPanelCompositionTypeOptions_feature: 'Longa-metragem / Filmes',
  filterPanelCompositionTypeOptions_others: 'Outros',
  filterPanelCompositionTypeOptions_psaPolicy: 'Institucional / Políticas',
  filterPanelCompositionTypeOptions_trailerTeaserPromo:
    'Trailer / Teaser / Promo',
  filterPanelDcpDownloadStatus: 'STATUS DE DOWNLOAD DO DCP',
  filterPanelDcpIngestStatus: 'STATUS DE INGESTÃO DO DCP',
  filterPanelKdmIngestStatus: 'STATUS DE INGESTÃO DO KDM',
  filterPanelKdmStatus: 'STATUS DE ENTREGA DO KDM',
  filterPanelKdmValidity: 'VALIDADE DO KDM',
  filterPanelTheatresPlaceHolder: 'Buscar cinemas',
  filterPanelTheatresTitle: 'CINEMAS',
  filters: 'Filtros',
  from_time_of_booking: 'a partir do momento da reserva.',
  fullAccess: 'Acesso total',
  future: 'Válido no futuro',
  gateway: 'Gateway',
  generateReport: 'Gerar relatório',
  groupCount_one: '{{count}} Grupo',
  groupCount_other: '{{count}} Grupos',
  groupName: 'Nome do grupo',
  groupsCreateGroupCancel: 'Cancelar',
  groupsCreateGroupCreateTheatreGroups: 'Criar grupos de cinema',
  groupsCreateGroupGroupCreated: 'Grupo criado',
  groupsCreateGroupGroupName: 'Nome do grupo',
  groupsCreateGroupGroupPlaceHolderName: 'Digite o nome do grupo',
  groupsCreateGroupHeaderTitle: 'Criar grupo',
  groupsCreateGroupSaveChanges: 'Salvar alterações',
  groupsCreateGroupTheatreSelection: 'Seleção de cinema',
  groupsHeaderCreateTheatreGroupButton: 'Criar grupo de cinemas',
  groupsHeaderViewLogsButton: 'Ver registros logs',
  groupUpdated: 'Grupo atualizado',
  holdoverKdmRequests: 'Solicitações de extensão de KDM',
  hour: 'Hora',
  iabScreens: 'Salas IAB',
  inbox: 'Caixa de entrada',
  invalidEmail: 'Endereço de e-mail inválido',
  ipRequired: 'O endereço IP é obrigatório',
  ipAddress: 'Endereço IP',
  ipAddress_1: 'ENDEREÇO IP',
  ipAlreadySelectedInForm:
    'Este IP já está selecionado/atribuído. Por favor, selecione outro IP.',
  ipCount_one: 'IPs (1)',
  ipCount_other: 'IPs ({{count}})',
  kdmDetails: 'Detalhes do KDM',
  kdmValidityTheatreTimeZone: 'Validade do KDM (Fuso horário do cinema)',
  lastUpdatedBy: 'Última atualização por',
  lastUpdatedOn: 'Última atualização em',
  linkExpiredOnDownload:
    'O download não pode ser iniciado. O link de entrega expirou ou não está mais elegível para download.',
  linkReceivedOn: 'Link recebido em',
  loading: 'Carregando',
  location: 'Localização',
  logsTheatreGroups: 'Registros: Grupos de cinema',
  minute: 'Minuto',
  moveModalText:
    'O dispositivo {{name}} será movido para espera standby. Deseja continuar?',
  moveTo: 'Mover para',
  moveToScreen: 'Sala {{number}}',
  moveToStandby: 'Mover para espera standby',
  moveToStandbyDevices: 'Mover para dispositivos em espera',
  moveToUnmapped: 'Mover para dispositivos da Sala {{number}}',
  movie: 'Filme',
  movieName: 'Nome do filme',
  multiThumbprintKdm: 'Salas KDM Multi-Thumbprint com servidor DC2 (DCP 2000)',
  multiThumbprintKdmOtherServices:
    'Salas KDM Multi-Thumbprint com outros servidores',
  name: 'Nome',
  needs_1_SM_RMB_msg:
    'Cada suíte deve conter exatamente 1 SM/1 RMB. Adicione um dispositivo SM/RMB com certificado para continuar.',
  newData: 'Novos dados',
  newRequestCreated:
    'Uma nova solicitação foi criada com o ID de solicitação {{requestId}}.',
  no_compositions: 'Sem composições',
  no_theatres: 'Nenhum cinema disponível',
  noAccess: 'Sem acesso',
  noBookings: 'Nenhuma reserva disponível',
  noData: 'Sem dados',
  noExpiredBookings: 'Nenhum download do WireLink expirado foi encontrado.',
  noIpFound: 'Nenhum IP disponível',
  noMatchFound: 'Nenhuma correspondência encontrada',
  noResultsFound: 'Nenhum resultado encontrado',
  normalKdm: 'KDM normal',
  notDownloaded: 'Não baixado',
  notSelected: 'Não selecionado',
  noWiretapAvailable: 'Nenhum WireTAP disponível',
  oldData: 'Dados antigos',
  optional: 'Opcional',
  osVersion: 'VERSÃO DO SO',
  pending: 'Pendente',
  readyToDownload: 'Pronto para baixar',
  receivedOn: 'Recebido em',
  recipientDetails: 'Detalhes do destinatário',
  recipientEmails: 'E-mails dos destinatários',
  remove: 'Remover',
  removeFromTheatre: 'Remover do cinema',
  removeModalText: 'Tem certeza de que deseja remover {{name}} do cinema?',
  removeUser: 'Remover usuário',
  removeUserConfirmation:
    'Remover este usuário removerá o acesso dele a esta empresa. O usuário não poderá mais entrar ou realizar ações.',
  reportInitiated: 'O relatório {{report}} foi iniciado.',
  reportReady: 'O relatório {{report}} está pronto.',
  reportsheaderTitle: 'Relatórios',
  requestedBy: 'Solicitado por',
  requestedKdmValidity: 'Validade de KDM solicitada',
  requestedOn: 'Solicitado em',
  requestFailed: 'Solicitação falhou',
  requestFailedMessage:
    'Falha ao enviar a solicitação. Por favor, tente novamente.',
  requestSent: 'Solicitação enviada',
  role: 'Função',
  roles: 'Funções',
  save: 'Salvar',
  saveChanges: 'Salvar alterações',
  screen: 'Sala',
  screenInactive: 'Inativo',
  screens: 'Salas',
  searchByLocation: 'Buscar por localização',
  searchByNameOrEmail: 'Buscar por nome ou e-mail',
  searchBySerialNo: 'Buscar por número de série',
  searchByTheatreGroup: 'Buscar por grupo de cinemas',
  searchByTheatreGroupName: 'Buscar por nome do grupo de cinemas',
  searchByTheatreName: 'Buscar por nome do cinema',
  searchCompositions: 'Buscar por nome da composição',
  searchCompositionsPlaceholder: 'Buscar composições',
  searchDeviceModel: 'Buscar modelo do dispositivo',
  searchForChain: 'Buscar rede de cinema',
  searchForLocation: 'Buscar localização',
  searchForOsVersion: 'Buscar versão do SO',
  searchForPublicIp: 'Buscar IP público',
  searchForSerialNumber: 'Buscar número de série',
  searchForTheatre: 'Buscar cinema',
  searchForWiretap: 'Buscar WireTAP',
  searchMovies: 'Buscar por nome do filme',
  searchPlaceholder: 'Buscar cinemas que você gerencia',
  searchSerialNumber: 'Buscar número de série',
  searchTheatres: 'Buscar por nome do cinema',
  selectIpAddress: 'Selecionar endereço IP',
  selectRole: 'Selecionar função',
  sendInvite: 'Enviar convite',
  serialNumber: 'Número de série',
  serialNumber_1: 'NÚMERO DE SÉRIE',
  show: 'Mostrar',
  showingCountResults_one: 'Mostrando 1 resultado para',
  showingCountResults_other: 'Mostrando {{count}} resultados para',
  showingResults: 'Mostrando {{start}}-{{end}} de {{total}} itens',
  showingResultsFor: 'Mostrando resultados para',
  showMore: 'Mostrar mais',
  softwareVersion: 'Versão do software',
  somethingWentWrong: 'Algo deu errado',
  standby: 'Espera (Standby)',
  standbyDevices: 'Dispositivos em espera',
  standbyHeader_one: 'Dispositivos em espera (1)',
  standbyHeader_other: 'Dispositivos em espera ({{count}})',
  status: 'Status',
  subnetMask: 'Máscara de sub-rede',
  suite: 'Suíte',
  suiteCreationRules: 'Regras de criação de suíte',
  suiteDevicesExpiredMsg:
    'A suíte possui dispositivos com certificados expirados',
  suiteEffectiveFrom: 'Suíte válida a partir de',
  suiteInvalid: 'Suíte inválida para geração de KDM',
  suiteLogs: 'Registros logs da suíte',
  suiteMustContain:
    'A suíte deve conter exatamente {{smCount}} dispositivo SM ou {{rmbCount}} dispositivo RMB.',
  suiteMustContainAdLd:
    'A suíte deve conter pelo menos 1 dispositivo adicional com a Função de Dispositivo como LD.',
  suiteMustContainLDorPR:
    'A suíte deve conter pelo menos 1 dispositivo adicional com a Função de Dispositivo como LD ou PR.',
  suiteMustContainSm:
    'A suíte deve conter exatamente {{smCount}} dispositivo SM.',
  suiteMustContainSMOBE:
    'A suíte deve conter exatamente 1 dispositivo SM / OBAE com SM.',
  suiteNo: 'Suíte {{number}}',
  theatre: 'Cinema',
  theatre_1: 'CINEMA',
  theatre_header: 'Cinema',
  theatreCount: 'Contagem de cinemas',
  theatreGroup: 'Grupo de cinemas',
  theatreGroupDeleted: 'Grupo de cinemas excluído',
  theatreGroupDeletedMessage: '{{groupName}} foi excluído',
  theatreGroupDetails: 'Detalhes do grupo de cinemas',
  theatreGroups: 'Grupos de cinema',
  theatreName: 'Nome do cinema',
  theatres: 'Cinemas',
  theatresList: 'Lista de cinemas',
  theatreSmall: 'Cinema',
  theatreTimeZone: 'Fuso horário do cinema',
  trackingInfo: 'Informações de rastreamento',
  unarchival_may_take: 'A desarquivação pode levar',
  undo: 'Desfazer',
  unmappedDevices_one: 'Dispositivo (1)',
  unmappedDevices_other: 'Dispositivos ({{count}})',
  untitled: 'Sem título',
  update: 'Atualizar',
  updatedBy: 'Atualizado por',
  updatedOn: 'Atualizado em',
  uploadCertificate: 'Enviar certificado',
  uploadDeviceCertificate: 'Enviar certificado do dispositivo',
  user: 'Usuário',
  userCount_one: '{{1}} Usuário',
  userCount_other: '{{count}} Usuários',
  userInviteSent: 'Convite de usuário enviado com sucesso',
  userLogs: 'Registros logs do usuário',
  userRemoved: 'Usuário removido',
  users: 'Usuários',
  usersHeaderButtonsInviteUser: 'Convidar usuário',
  usersHeaderButtonsViewLogs: 'Ver registros logs',
  usersHeaderTitle: 'Gerenciar usuários',
  validFrom: 'Válido a partir de',
  validNow: 'Válido agora',
  validTo: 'Válido até',
  verificationStatus: 'Status de verificação',
  viewAll: 'Ver tudo',
  viewAllTheatreGroups: 'Ver todos os grupos de cinema',
  viewCreditOffset: 'Créditos: {{value}}',
  viewSuiteLogs: 'Ver registros logs da suíte',
  viewTheatreGroup: 'Ver grupo de cinemas',
  warning: 'Aviso',
  wireLinkCopiedToClipboard: 'WireLink copiado para a área de transferência',
  wireLinkCopyFailed: 'Não foi possível copiar. Por favor, tente novamente.',
  wireLinkDetails: 'Detalhes do WireLink',
  wireLinks: 'WireLinks',
  wiretaps: 'WireTAPs',
  wiretapStatusReport: 'Relatório de status do WireTAP',
  removeDevice: 'Remover dispositivo',
  deleteIpTitle: 'Excluir endereço IP - {{ip}}',
  appliances: 'Aparelhos',
  noResultsFor: 'Nenhum resultado para',
  city: 'Cidade',
  province: 'Província',
  country: 'País',
  confirmAction: 'Confirmar ação',
  RequestId: 'ID da solicitação: {{requestId}}',
  moveToUnmapped_name: 'Mover para dispositivos {{name}}',
  language: 'Idioma',
  subtitleLanguage: 'Idioma das legendas',
  mainCaption: 'Legenda principal',
  ratings: 'Classificações',
  type: 'Tipo',
  dciStandard: 'Padrão DCI',
  closedSubtitles: 'Legendas fechadas',
  frameRate: 'Taxa de quadros',
  audioFormats: 'Formatos de áudio',
  resolution: 'Resolução',
  closedCaptions: 'Legendas ocultas',
  stereoType: 'Tipo de estéreo',
  aspectRatio: 'Proporção',
};
